export default {
    tours: [],
    users: [],
    posts: [],
    roles: [],
    rights: [],
    operations: [],
    reports: [],
    finishedTests: [],
    notFinishedTests: [],
    additionalProps: [],
    groups: [],
    themes: []
}